import { render, staticRenderFns } from "./ModalSchriftFamilie.vue?vue&type=template&id=09a9a2d4&scoped=true"
import script from "./ModalSchriftFamilie.vue?vue&type=script&lang=js"
export * from "./ModalSchriftFamilie.vue?vue&type=script&lang=js"
import style0 from "./ModalSchriftFamilie.vue?vue&type=style&index=0&id=09a9a2d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09a9a2d4",
  null
  
)

export default component.exports